export const MIGRATION_WINDOW_DURATION = 7;

export const getLegacyMigrationTopbarMessage = (daysLeft: number): string =>
  `Your LiveChat upgrades to Text in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}.`;

export const LEGACY_MIGRATION_MODAL_TITLE = 'Your LiveChat upgrades to Text';

export const LEGACY_MIGRATION_COPY = {
  primaryAction: 'See Text now',
} as const;

export const LEGACY_MIGRATION_MODAL_COPY = {
  descriptionHighlight: '220 improvements across the Inbox, customer profiles, reporting, and more.',
  description:
    'Reach visitors with targeted campaigns, see their chats and tickets together, and use AI to answer questions and qualify leads.',
  primaryAction: "See what's new",
} as const;

export enum LegacyMigrationEvent {
  ModalDisplayed = 'Migration Info Modal Displayed',
  ModalDismissed = 'Migration Info Modal Dismissed',
  ModalRemindMeLaterClicked = 'Migration Info Modal Remind Me Later Clicked',
  ModalPrimaryActionClicked = 'Migration Info Modal Primary Action Clicked',
  TopbarDisplayed = 'Migration Info Alert Displayed',
  TopbarDismissed = 'Migration Info Alert Dismissed',
  TopbarCtaClicked = 'Migration Info Alert Cta Clicked',
}
